'use strict';

var _toConsumableArray = require("/Users/ajussis/Develop/gatsby.ipcc-ar6-wg1/node_modules/@babel/runtime/helpers/toConsumableArray.js");
var arrify = function arrify(value) {
  if (value === null || value === undefined) {
    return [];
  }
  if (Array.isArray(value)) {
    return value;
  }
  if (typeof value === 'string') {
    return [value];
  }
  if (typeof value[Symbol.iterator] === 'function') {
    return _toConsumableArray(value);
  }
  return [value];
};
module.exports = arrify;